var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "invoiceDialog",
          attrs: {
            "append-to-body": true,
            title: "发票信息",
            visible: _vm.collectionShow,
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.collectionShow = $event
            },
          },
        },
        [
          _c("div", [_vm._v("用户发票信息填写二维码")]),
          _c("qr", {
            staticStyle: {
              "text-align": "center",
              display: "flex",
              "margin-left": "120px",
            },
            attrs: { logoSrc: _vm.logoSrc, text: _vm.text },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }